// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1PmvS","location":"Header_location__1KqHz"};